import { Guardian } from '@xaamin/guardian';

Guardian.define('cliente.crear', (user) => {
  return user.can('cliente.crear');
});

Guardian.define('cliente.listar', (user) => {
  return user.can('cliente.listar');
});

Guardian.define('cliente.info', (user) => {
  return user.can('cliente.info');
});

Guardian.define('cliente.editar', (user) => {
  return user.can('cliente.editar');
});

Guardian.define('cliente.editar.servicios', (user) => {
  return user.can('cliente.editar.servicios');
});

Guardian.define('cliente.reenviar.invitacion', (user) => {
  return user.can('cliente.reenviar.invitacion');
});

Guardian.define('cliente.suspender', (user) => {
  return user.can('cliente.suspender');
});

Guardian.define('cliente.activar', (user) => {
  return user.can('cliente.activar');
});

Guardian.define('cliente.eliminar', (user) => {
  return user.can('cliente.eliminar');
});

Guardian.define('cliente.cambiar.sesion', (user) => {
  return user.can('cliente.cambiar.sesion');
});

Guardian.define('cliente.asignar.hits', (user) => {
  return user.can('cliente.asignar.hits');
});
